import { AlertWidgetType } from "../types";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./AlertWidget.css";

export interface IAlertWidgetParam {
  title: string | "";
  description: string | "";
  urlLink: string | "";
  urlText: string | "";
  typeAlert: AlertWidgetType | AlertWidgetType.CENTIMETER;
  includeNewLine: boolean | false;
  className?: string;
  values?: { [key: string]: any }; // Add this line
}

const AlertWidget = (props: IAlertWidgetParam) => {
  const imageSrcType =
    props.typeAlert === AlertWidgetType.WARNING
      ? "/img/icon-warning.png"
      : props.typeAlert === AlertWidgetType.TSHIRT
      ? "/img/icon-tshirt.png"
      : "/img/icon-centimeter.png";

  const imageAltType =
    props.typeAlert === AlertWidgetType.WARNING
      ? "Warning"
      : props.typeAlert === AlertWidgetType.TSHIRT
      ? "T-Shirt"
      : "Centimeter";
  return (
    <>
      <Row className="tag-fitprenda-alert">
        <Col xs={2} xxl={2} className="py-3 fitprenda-para-prestar-atencion">
          <img
            className="fitprenda-alert-widget-image"
            src={imageSrcType}
            alt={imageAltType}
            width={47.9}
            height={47}
          />
        </Col>
        <Col className="py-3 main-home-alert-widget">
          <p className="font-fitprenda-alert-title">
            <FormattedMessage
              id={props.title}
              defaultMessage={props.title}
              values={props.values}
            />
          </p>
          {props.description ? (
            <p className="font-fitprenda-alert-description">
              <FormattedMessage
                id={props.description}
                defaultMessage={props.description}
              />
            </p>
          ) : (
            <></>
          )}
          {props.includeNewLine ? (
            <br className="d-xxl-block d-sm-none d-lg-none" />
          ) : (
            <></>
          )}
          {props.urlLink ? (
            <p className="font-fitprenda-alert-link">
              <a href={props.urlLink} className="link-fitprenda-action">
                <FormattedMessage
                  id={props.urlText}
                  defaultMessage={props.urlText}
                />
              </a>
            </p>
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </>
  );
};

export default AlertWidget;
